module.exports = __webpack_public_path__ + "img/01_abe_01.888c6b03.jpg";